import React, { useMemo } from "react";
// import { Row, Col, Button } from "antd";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { awardTypesIcons } from "../../Config/helpers/constants";
import { segregateAndGroupEventAwardsByTypeAndRank } from "../../utils/utilityFunctions";

// event awards component
const eventAwards = (data) => {
  const awardsDetail = useMemo(
    () => segregateAndGroupEventAwardsByTypeAndRank(data?.awardsDetail),
    [data?.awardsDetail]
  );
  return (
    <div className="timelineiconpadding">
      {Object.keys(awardsDetail)?.length > 0 ? (
        Object.keys(awardsDetail)?.map((award) => {
          console.log("single awards", awardsDetail?.[award]);
          const individualTypeAward = awardsDetail?.[award];
          return (
            <>
              {individualTypeAward?.length > 0 &&
                individualTypeAward?.map((singleAward) => (
                  <p key={singleAward?._id} className="timelineiconpadding flexcenter">
                    <img
                      alt=""
                      className="timelineiconplacecenter"
                      src={`/images/icons/${
                        awardTypesIcons.includes(singleAward?.awardType)
                          ? `${singleAward?.awardType}`
                          : "certificate"
                      }.svg`}
                      height="25px"
                      width="25px"
                    />

                    <div>
                      <p className="p-0 m-0"> {singleAward?.title}</p>
                      <p className="p-0 m-0"> Rank: {singleAward?.rank}</p>
                      {singleAward?.awardValue && (
                        <p className="p-0 m-0">Cash: {singleAward?.awardValue} </p>
                      )}
                    </div>
                  </p>
                ))}
            </>
          );
        })
      ) : (
        <p>No Awards found</p>
      )}
    </div>
  );
};
const Awards = ({ type, data }) => {
  const navigate = useNavigate();

  return (
    <div>
      <h1 className="timelineAboutpadding" style={{ padding: "3% 3% 5% 0%" }}>
        Awards & Achievements
      </h1>

      {type === "event" ? (
        eventAwards(data)
      ) : (
        <>
          <p className="timelineiconpadding flexcenter">
            <img
              alt=""
              className="timelineiconplacecenter"
              src="/images/icons/moneycolor.png"
              height="25px"
              width="25px"
            />
            <span className="sideItemsText">
              {data?.totalCash || data?.data?.totalCash || data?.teamAwardsDetails?.totalCash || 0}{" "}
              Rs ( Winning Team )
            </span>
          </p>
          <p className="timelineiconpadding flexcenter">
            <img
              alt="img"
              className="timelineiconplacecenter"
              src="/images/icons/badge.png"
              height="32px"
              width="23px"
            />

            <span className="sideItemsText ">
              {data?.totalCertificates ||
                data?.data?.totalCertificates ||
                data?.teamAwardsDetails?.totalCertificates ||
                0}{" "}
              Certificates
            </span>
          </p>
          <p className="timelineiconpadding flexcenter">
            <img
              alt=""
              className="timelineiconplacecenter"
              src="/images/icons/badge-1.png"
              height="25px"
              width="23px"
            />
            <span className="sideItemsText ">
              {" "}
              {data?.totalShields ||
                data?.data?.totalShields ||
                data?.teamAwardsDetails?.totalShields ||
                0}{" "}
              Shields ( Winning Team ){" "}
            </span>
          </p>
        </>
      )}
      {/* Only show this button when event is not yet completed  */}
      {type === "event" && data?.awardsDetail?.length > 0 && !data?.complete && (
        <Button
          onClick={() => navigate(`/view/event/${data?._id}/event-awards`)}
          style={{
            width: "35%",
            margin: "auto"
          }}
          className="registerbutton btnMobileDimensions"
          type="primary">
          Show More
        </Button>
      )}
    </div>
  );
};

export default Awards;
